import * as AC from './styled';

interface IProps {
    title: string,
    text: string,
}

const AccumulateCard = ({ title, text }: IProps): JSX.Element => {
    return (
        <AC.CardWrapper>
            <AC.CardTitle dangerouslySetInnerHTML={{ __html: title }}/>
            <AC.CardText>{text}</AC.CardText>
        </AC.CardWrapper>
    );
};

export default AccumulateCard;
